import { Reveal } from "@/components/Motion";

export default function MethodSteps({ steps, dark = false }) {
  return (
    <div data-testid="method-steps">
      {steps.map((step, i) => (
        <Reveal key={step.n} delay={i * 0.05}>
          <div
            className={`group relative grid grid-cols-12 gap-4 lg:gap-10 items-center py-10 lg:py-14 border-t overflow-hidden ${
              dark ? "border-ivory/15" : "border-taupe/30"
            } transition-colors duration-500 ${dark ? "hover:bg-ivory/5" : "hover:bg-peach/60"} px-3 lg:px-8`}
            data-testid={`method-step-${step.n}`}
          >
            <span
              aria-hidden="true"
              className={`pointer-events-none select-none absolute -top-4 right-2 lg:right-8 font-display italic leading-none opacity-[0.08] text-[7rem] lg:text-[11rem] transition-transform duration-700 group-hover:scale-110 ${
                dark ? "text-ivory" : "text-charcoal"
              }`}
            >
              {step.n}
            </span>

            <span
              className={`col-span-3 lg:col-span-2 flex items-center justify-center w-14 h-14 lg:w-16 lg:h-16 rounded-full font-medium text-lg lg:text-xl ${
                dark ? "bg-sand/20 text-sand" : "bg-peach text-deeptaupe"
              }`}
            >
              {step.n}
            </span>

            <h3
              className={`col-span-9 lg:col-span-4 font-display text-4xl lg:text-6xl leading-none transition-transform duration-500 group-hover:translate-x-2 ${
                dark ? "text-ivory" : "text-charcoal"
              }`}
            >
              {step.title}
            </h3>

            <p
              className={`col-span-12 lg:col-span-6 lg:col-start-7 text-base lg:text-lg leading-relaxed relative ${
                dark ? "text-ivory/75" : "text-charcoal/80"
              }`}
            >
              {step.text}
            </p>
          </div>
        </Reveal>
      ))}
      <div className={`border-t ${dark ? "border-ivory/15" : "border-taupe/30"}`} />
    </div>
  );
}
